import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const MpesaContext = createContext(null);

type Props = {
  children: ReactElement;
};

const MpesaProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post(
        "account/subscriptions/mpesa/safari",
        payload,
      );
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <MpesaContext.Provider value={contextValue}>
      {children}
    </MpesaContext.Provider>
  );
};

export default MpesaProvider;
